/*------------------------------*
 | @author  Cameron Slupeiks    |
 | @date    2020.20.26          |
 | Copyright Brash Inc. (2020)  |
 *------------------------------*/

import { initI18n } from "./i18n";
import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";
//Import Mapbox CSS
import "mapbox-gl/dist/mapbox-gl.css";
import { GlobalWorkerOptions as pdfjsWorkerOptions } from "pdfjs-dist";
import React from "react";
import App from "./app";
import appConfig from "@config/app-config.json";
import { API_NAME_MAPBOX } from "./dao/amplify-utils";
import { configure as configureVelavu } from "velavu-js-api";
import { createRoot } from "react-dom/client";

//Configure PDF.js worker
pdfjsWorkerOptions.workerSrc = "pdf.worker.js";

//Initialize i18n
initI18n();

Amplify.configure({
	Auth: {
		Cognito: {
			identityPoolId: appConfig.auth.identityPoolId,
			userPoolId: appConfig.auth.userPoolId,
			userPoolClientId: appConfig.auth.userPoolWebClientId,
		},
	},
	API: {
		REST: {
			[API_NAME_MAPBOX]: {
				endpoint: appConfig.mapboxEndpoint,
			},
		},
	},
});

configureVelavu({
	endpoint: appConfig.velavuEndpoint,
	getToken: async () => {
		const authSession = await fetchAuthSession();
		const authToken = authSession.tokens?.idToken?.toString();
		if (authToken === undefined) {
			throw new Error(
				"Attempt to send request to Velavu-API without authorization",
			);
		}

		return authToken;
	},
});

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
